import Vue from 'vue'
import Vuex from 'Vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
    clientId: 1, // 用来标识哪个端的编号
    env: 'test', // 环境的配置[test: 开发环境, release: 正式环境]
    logo: '', // logo图片的地址
    miniLogo: '', // 小logo图片的地址
    background: '', // 背景图片
    clientConfig: {
        test: [{ //  admin
            client_id: 1,
            client_secret: 'pIj5txyw06mOrzGnwjLYt4EMtiHVs3Hm1w9foTmw'
        }, { // agent
            client_id: 2,
            client_secret: 'rLurDLbisteSJ2ribCmfJe4ABa3MiVNVmdOGYWi4'
        }, { // member
            client_id: 3,
            client_secret: 'aRowuGfFpKY6uKPuv11AFW00bKG4a1n6j8gYJO6E'
        }]
    },
    /* -- 账号相关 start -- */
    tokon: '', // 登录验证令牌
    hlftokon: '', // 海量发登录验证令牌
    tokonKey: 'TOKON_KEY', // 用于本地存储tokon的key
    hlftokonKey: 'HLFTOKON_KEY',
    authorizd: false, // 标识是否已登录
    userInfo: {}, // 当前登录用户的信息
    /* -- 账号相关  end  -- */
    config: {}, // 全局配置
    currMenu: null, // 当前菜单所包含的配置
    currPage: null, // 当前操作页面
    hubbleId: 0 // 2019-10-30添加，区分显示需要带入的上传参数
}

const getters = {
    clientId: state => state.clientId,
    env: state => state.env,
    logo: state => state.logo,
    miniLogo: state => state.miniLogo,
    background: state => state.background,
    clientConfig: state => state.clientConfig,
    /* -- 账号相关 start -- */
    tokon: state => state.tokon,
    tokonKey: state => state.tokonKey,
    hlftokon: state => state.hlftokon,
    hlftokonKey: state => state.hlftokonKey,
    authorizd: state => state.authorizd,
    userInfo: state => state.userInfo,
    /* -- 账号相关  end -- */
    config: state => state.config,
    currMenu: state => state.currMenu,
    currPage: state => state.currPage,

    hubbleId: state => state.hubbleId,
}

export default new Vuex.Store({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/store/index.js